import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getLoadedStatus } from '../../helpers/loaderHelpers';

// Components
import withLoader from '../../components/Loader/withLoader.js';
import ExpansionCard from '../../components/ExpansionCard/ExpansionCard.js';
import CardSpacer from '../../components/CardSpacer/CardSpacer';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact.js';
import ContactLayout from './ContactLayout';
import ContactForm from './ContactForm/ContactForm';
import analyticsApi from '../../api/analytics';
import PersonIcon from '@material-ui/icons/PersonPinOutlined';
import ChatIcon from '@material-ui/icons/ChatBubbleOutline';
import PhoneIcon from '@material-ui/icons/PhoneOutlined';
import LanguageIcon from '@material-ui/icons/TranslateOutlined';
import FormIcon from '../../components/Icons/Wysiwyg/Wysiwyg';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

class Contact extends React.Component {
  state = {
    hasLoaded: false,
  };

  componentDidMount() {
    const { onLoadComplete } = this.props;
    onLoadComplete();
  }

  componentDidUpdate() {
    const { hasLoaded } = this.state;

    if (
      getLoadedStatus(this.getLoadedStatuses(this.props)) == 'LOADED' &&
      !hasLoaded
    ) {
      // Once all required data has loaded, store that fact.
      this.setState({ hasLoaded: true });
    }
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status or the loading has not
    // previously completed.
    const { hasLoaded } = this.state;

    if (
      getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED' ||
      hasLoaded
    ) {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy, contactDetails } = props;
    const loaded = [tenancy.loaded, contactDetails.loaded];
    return loaded;
  }

  render() {
    const {
      tenancy,
      goDash,
      toggleContactModal,
      signout,
      inOutage,
      outageFrom,
      outageTo,
      outageMessage,
      contactDetails,
      getContactDetails,
    } = this.props;

    const contactData = contactDetails.data.contactDetails;

    const failureText = (
      <ReplaceContact
        content={portalContent.APP_ERROR_MESSAGE}
        action={toggleContactModal}
        isLink={true}
      />
    );

    let tenancyData = null;
    if (tenancy.loaded == 'LOADED') {
      tenancyData = tenancy.data;
    }

    const WrappedContactLayout = withLoader(ContactLayout);

    const sections = [];

    contactSections.forEach((section, i) => {
      let icon;
      switch (section.icon) {
        case 'Form':
          icon = FormIcon;
          break;
        case 'Language':
          icon = LanguageIcon;
          break;
        case 'Person':
          icon = PersonIcon;
          break;
        case 'Phone':
          icon = PhoneIcon;
          break;
        default:
          icon = ChatIcon;
          break;
      }
      sections.push(
        <ExpansionCard
          title={section.title}
          content={
            section.content ? (
              <div>
                <ReplaceContact
                  content={section.content}
                  action={toggleContactModal}
                  isLink={true}
                />
              </div>
            ) : null
          }
          icon={icon}
          form={
            section.hasForm ? (
              <ContactForm
                enquiryOptions={section.enquiryOptions}
                enquiryTypeLabel={section.enquiryTypeLabel}
                selectPlaceholder={section.selectPlaceholder}
                detailsLabel={section.detailsLabel}
                detailsPlaceholder={section.detailsPlaceholder}
                timeFieldIntro={
                  <ReplaceContact
                    content={section.timeFieldIntro}
                    action={toggleContactModal}
                    isLink={true}
                  />
                }
                submitButtonLabel={section.submitButtonLabel}
                dialogTitle={section.dialogTitle}
                dialogContent={
                  <ReplaceContact
                    content={section.dialogContent}
                    action={toggleContactModal}
                    isLink={true}
                  />
                }
                failureText={failureText}
                onError={signout}
                gaEvent={analyticsApi.event}
                contactData={contactData}
                refreshContacts={getContactDetails}
              />
            ) : null
          }
          key={`card-${i}`}
          openGAEvent={
            section.hasForm
              ? () => analyticsApi.event('Contact', 'Click', 'Open form')
              : null
          }
        />
      );
      if (i < contactSections.length - 1) {
        sections.push(<CardSpacer key={`spacer-${i}`} />);
      }
    });

    return (
      <WrappedContactLayout
        loaded={this.getLoadedStatuses()}
        sections={sections}
        backAction={goDash}
        failureText={failureText}
        onError={signout}
        inOutage={inOutage}
        outageFrom={outageFrom}
        outageTo={outageTo}
        outageMessage={
          outageMessage && (
            <ReplaceContact
              content={outageMessage}
              action={toggleContactModal}
              isLink={true}
            />
          )
        }
      />
    );
  }
}

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  contactDetails: state.customer.contactDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Contact);
